/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAutomaticPromotionRequest
 */
export interface UpdateAutomaticPromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAutomaticPromotionRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAutomaticPromotionRequest
     */
    promotionId: string | null;
}

/**
 * Check if a given object implements the UpdateAutomaticPromotionRequest interface.
 */
export function instanceOfUpdateAutomaticPromotionRequest(value: object): value is UpdateAutomaticPromotionRequest {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('promotionId' in value) || value['promotionId'] === undefined) return false;
    return true;
}

export function UpdateAutomaticPromotionRequestFromJSON(json: any): UpdateAutomaticPromotionRequest {
    return UpdateAutomaticPromotionRequestFromJSONTyped(json, false);
}

export function UpdateAutomaticPromotionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAutomaticPromotionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'promotionId': json['promotionId'],
    };
}

export function UpdateAutomaticPromotionRequestToJSON(json: any): UpdateAutomaticPromotionRequest {
    return UpdateAutomaticPromotionRequestToJSONTyped(json, false);
}

export function UpdateAutomaticPromotionRequestToJSONTyped(value?: UpdateAutomaticPromotionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'promotionId': value['promotionId'],
    };
}

